import { deviceType } from "@tm/isomorphic-utils";
import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled, { css } from "styled-components";

export const CardWrapper = styled.div`
  position: relative;
  flex: 0 0 calc((100% - 72px) / 4);
  max-width: calc((100% - 72px) / 4);
  scroll-snap-align: start;
  display: flex;
  flex-direction: column;

  @media ${deviceType.mobile} {
    flex: 1 0 100%;
    max-width: 100%;
    scroll-snap-align: none;
  }
`;

export const CardContainer = styled.div<{
  $isRecommended?: boolean;
  $borderColor?: string;
}>`
  background: ${theme.whiteText};
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 8px 16px;
  border: 1px solid
    ${(p) =>
      p.$isRecommended ? p.$borderColor || theme.blueText : theme.lightSilver};
  position: relative;
  z-index: 1;

  ${(p) =>
    p.$isRecommended &&
    css`
      background: ${theme.blueText2};
    `}
`;

export const Badge = styled.span<{ $gradient?: string[] }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 16px;
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.bold};
  color: ${theme.whiteText};
  background: ${(p) =>
    p.$gradient?.length === 2
      ? `linear-gradient(9deg, ${p.$gradient[0]}, ${p.$gradient[1]})`
      : theme.blueGradient};
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  text-transform: uppercase;
  z-index: 2;
`;

export const CardInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  flex: 1;

  button {
    box-shadow: none;
  }
`;

// ──── Header (title + price) ────

export const CardHeader = styled.div`
  width: 100%;
  background: ${theme.whiteText};
  border-radius: 12px;
  box-shadow: 0px 6px 40px ${theme.greyText6}40;
  padding: 15px 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 101px;
  position: relative;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 2px;
`;

export const SavingsTag = styled.span<{ $isMyCash?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 6px;
  border-radius: 100px;
  background: linear-gradient(
    to right,
    ${(p) => (p.$isMyCash ? theme.greenText2 : theme.neonGreen)},
    ${theme.whiteText}
  );
  font-size: ${fontSize.font12};
  font-weight: ${(p) => (p.$isMyCash ? fontWeight.bold : fontWeight.black)};
  color: ${(p) => (p.$isMyCash ? theme.blackText : theme.greenText)};
  white-space: nowrap;
`;

export const SavingsTagIcon = styled.img`
  width: 12px;
  height: 12px;
  flex-shrink: 0;
`;

export const HeaderPersuasionIcon = styled.img`
  width: 40px;
  height: 40px;
  position: absolute;
  right: 10px;
  bottom: 10px;
  object-fit: contain;
`;

// ──── Benefits ────

export const BenefitsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  flex: 1;
`;

export const BenefitRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
`;

export const BenefitIcon = styled.img`
  width: 12px;
  height: 12px;
  flex-shrink: 0;
`;

// ──── Footer Persuasion ────

export const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${theme.yellowText2}6b;
  border: 1px solid ${theme.yellowText4};
  border-radius: 0 0 16px 16px;
  padding: 24px 12px 12px;
  width: 95%;
  box-sizing: border-box;
  margin: -14px auto 0;
  z-index: 0;

  @media ${deviceType.mobile} {
    width: 92%;
  }
`;

export const FooterIcon = styled.img`
  width: 12px;
  height: 12px;
  flex-shrink: 0;
`;

// ──── Text layout wrappers ────

export const OriginalPriceText = styled.span`
  text-decoration: line-through;
  white-space: nowrap;
`;

export const UnitText = styled.span`
  white-space: nowrap;
`;

export const BenefitTitleText = styled.span`
  flex: 1;
  min-width: 0;
`;

export const BenefitDescText = styled.span`
  text-align: right;
  white-space: nowrap;
`;

export const FooterContent = styled.span`
  flex: 1;
  line-height: 1.3;
`;
